module.exports = __webpack_public_path__ + "img/WECHAT1.78dbede9.svg";